module.exports = __webpack_public_path__ + "img/message-catch.7dd16df6.svg";